import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LayoutDashboard, Users, Briefcase, Megaphone, Shield, Receipt, UserCog, ShieldAlert } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { hasPerm } from "../../lib/perms";

export const AdminTabs = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const tabs = [
    { to: "/admin", icon: LayoutDashboard, label: t("admin.tabs.overview"), end: true, perm: "view_metrics" },
    { to: "/admin/users", icon: Users, label: t("admin.tabs.users"), perm: "manage_users" },
    { to: "/admin/jobs", icon: Briefcase, label: t("admin.tabs.jobs"), perm: "manage_jobs" },
    { to: "/admin/receipts", icon: Receipt, label: t("admin.tabs.receipts"), perm: "view_revenue" },
    { to: "/admin/ads", icon: Megaphone, label: t("admin.tabs.ads"), perm: "manage_ads" },
    { to: "/admin/subadmins", icon: Shield, label: t("admin.tabs.subadmins"), perm: "manage_subadmins" },
    { to: "/admin/deletion-requests", icon: ShieldAlert, label: t("admin.tabs.deletionRequests"), perm: "delete_accounts" },
    { to: "/admin/account", icon: UserCog, label: t("admin.tabs.account"), always: true },
  ].filter((tab) => tab.always || hasPerm(user, tab.perm));

  return (
    <div className="flex gap-1 overflow-x-auto no-scrollbar mb-6 border-b border-stone-border" data-testid="admin-tabs">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            data-testid={`atab-${tab.to.split("/").pop() || "overview"}`}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${
                isActive ? "border-brand text-brand" : "border-transparent text-stone-sub hover:text-brand"
              }`
            }
          >
            <Icon className="w-4 h-4" /> {tab.label}
          </NavLink>
        );
      })}
    </div>
  );
};
